import GrayCard from "components/gray-card";
import DragNDrop from "components/inputs/dragNdrop";
import Typography from "components/typography";

import React from "react";
import styled from "styled-components";
import { IMusicData, ITrackRelease, MusicDataKeys } from "types/musicData";
import { Colors } from "utils/colors";
import TrackItem from "./components/track-item";

interface StepOneProps {
  musicData: IMusicData;
  handleChange: (key: MusicDataKeys, value: any) => void;
  setActiveTrack: (index: number) => void;
}
const StepOne = ({ musicData, handleChange, setActiveTrack }: StepOneProps) => {
  return (
    <Container>
      <GrayCard title="Cover Artwork">
        <FlexBox>
          <UploadArea>
            {!musicData.coverImage && (
              <DragNDrop
                setFile={(file) => handleChange("coverImage", file)}
                limit={5}
              />
            )}
            {musicData.coverImage && (
              <UploadAreaImage
                src={URL.createObjectURL(musicData.coverImage)}
                alt="cover-image"
              />
            )}
            {musicData.coverImage && (
              <RemoveFileButton
                onClick={() => handleChange("coverImage", undefined)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M20.0039 9.99951C20.0039 15.5223 15.5267 19.9995 10.0039 19.9995C4.48106 19.9995 0.00390625 15.5223 0.00390625 9.99951C0.00390625 4.47666 4.48106 -0.000488281 10.0039 -0.000488281C15.5267 -0.000488281 20.0039 4.47666 20.0039 9.99951ZM6.97354 6.96916C7.26643 6.67627 7.7413 6.67627 8.03421 6.96916L10.0039 8.93881L11.9735 6.96918C12.2664 6.67629 12.7413 6.67629 13.0342 6.96918C13.3271 7.26207 13.3271 7.73695 13.0342 8.02981L11.0645 9.99951L13.0342 11.9691C13.3271 12.262 13.3271 12.7369 13.0342 13.0298C12.7413 13.3227 12.2664 13.3227 11.9735 13.0298L10.0039 11.0602L8.03421 13.0298C7.74133 13.3227 7.26645 13.3227 6.97356 13.0298C6.68067 12.7369 6.68067 12.262 6.97356 11.9692L8.9432 9.99951L6.97354 8.02981C6.68064 7.73693 6.68064 7.26205 6.97354 6.96916Z"
                    fill="#CDCDCD"
                  />
                </svg>
              </RemoveFileButton>
            )}
          </UploadArea>
          <ArtReqText>
            <Typography weight="semibold" mb="0.8">
              Artwork Requirements
            </Typography>
            <ul
              style={{
                color: Colors.grey500,
                padding: "0",
                paddingLeft: "1rem",
                margin: 0,
                width: "70%"
              }}
            >
              <li>
                <Typography size="s">
                  Cover art must be a square .jpg or .png file
                </Typography>
              </li>
              <li>
                <Typography size="s">
                  Cover art must be 3000 x 3000 px
                </Typography>
              </li>
              <li>
                <Typography size="s">
                  Don’t upload blurry or pixelated artworks
                </Typography>
              </li>
              <li>
                <Typography size="s">
                  Art must not contain website addresses, brand logos, social
                  media handles or logos, any text except artists names and/or
                  name of release
                </Typography>
              </li>
            </ul>
            <Typography size="s" color={Colors.grey500} mt="0.4">
              If it contains any of the above, your release will be rejected by
              stores
            </Typography>
          </ArtReqText>
        </FlexBox>
      </GrayCard>
      <GrayCard title="Track List">
        {musicData.trackList.map((track, index) => (
          <TrackItem
            editTrack={() => {
              setActiveTrack(index);
            }}
            key={index}
            track={track}
            number={index + 1}
          />
        ))}
      </GrayCard>
    </Container>
  );
};

export default StepOne;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const FlexBox = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 1rem;
  @media only screen and (max-width: 769px) {
    flex-direction: column;
    row-gap: 2.4rem;
  }
`;

const UploadArea = styled.div`
  width: 24.6rem;
  height: 24.6rem;
  position: relative;
  @media only screen and (max-width: 769px) {
    width: 100%;
    height: 30rem;
  }
`;

const UploadAreaImage = styled.img`
  width: 100%;
  height: 100%;
  position: absolute;
  object-fit: cover;
  border-radius: 8px;
  @media only screen and (max-width: 769px) {
    object-fit: contain;
  }
`;

const RemoveFileButton = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(50%, -50%);
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

const ArtReqText = styled.div`
  width: 60%;
  @media only screen and (max-width: 769px) {
    width: 100%;
  }
`;
